export default __webpack_public_path__ + "static/media/sasaki-logo-white.f27b7fe8.png";